import htmlFractions from './htmlFractionConversion';

const getPrettyQuantity = (quantity) => {
    let whole = Math.floor(quantity) || ''; // get the whole number, if 0 return emtpy string
    let fraction = quantity - whole;
    return whole + (htmlFractions[fraction.toFixed(4)] || '');
};

export default getPrettyQuantity;